import type { SmartLinkIcon } from './smartLinkTypes.ts';

// ORS returns some third-party icons (Slack, Google Docs, ...) as `@atlassian/logo-third-party`
// raw app icons: an SVG data URI that already draws the ADS tile and its border. The generator's
// fixed template clips the artwork to `tile-content`, which favicons and glyph SVGs never do.
// CCINT-9530
const FRAMED_APP_TILE_PATTERN = /^data:image\/svg\+xml,[\s\S]*?<clipPath id=['"]tile-content['"]/;

/** The icon already carries its own tile and border, so wrapping it in ours would double it. */
export const isFramedAppTileIcon = (icon: SmartLinkIcon): boolean =>
	icon.kind === 'image' && FRAMED_APP_TILE_PATTERN.test(icon.src);
